<template>
  <div>
    <van-nav-bar title="消息中心" fixed class="jump-nav-bar" />
    <div class="cont">
        <van-row
          class="item"
          @click.native="goChat(item)"
          v-for="(item,index) of list"
          :key="index"
        >
          <van-col span="5" class="left">
            <div class="avator bg-orange" v-if="item.messageType==6">
              <img src="../../assets/img/xitong.png" />
              <span class="jump-usercent-orderste-dot2" v-if="item.sum!=0">{{item.sum}}</span>
            </div>
            <div class="avator bg-purple" v-if="item.messageType==1">
              <img src="../../assets/img/dingdan.png" />
              <span class="jump-usercent-orderste-dot2" v-if="item.sum!=0">{{item.sum}}</span>
            </div>
            <div class="avator bg-green" v-if="item.messageType==2">
              <img src="../../assets/img/zhifu-01.png" />
              <span class="jump-usercent-orderste-dot2" v-if="item.sum!=0">{{item.sum}}</span>
            </div>
            <div class="avator bg-pink" v-if="item.messageType==3">
              <img src="../../assets/img/wj-jktzd.png" />
              <span class="jump-usercent-orderste-dot2" v-if="item.sum!=0">{{item.sum}}</span>
            </div>
            <div class="avator bg-cyan" v-if="item.messageType==4">
              <img src="../../assets/img/jifen.png" />
              <span class="jump-usercent-orderste-dot2" v-if="item.sum!=0">{{item.sum}}</span>
            </div>
            <div class="avator bg-blue" v-if="item.messageType==5">
              <img src="../../assets/img/shenpi.png" />
              <span class="jump-usercent-orderste-dot2" v-if="item.sum!=0">{{item.sum}}</span>
            </div>
            <div class="avator bg-yellow" v-if="item.messageType==7">
              <img src="../../assets/img/zhekou.png" />
              <span class="jump-usercent-orderste-dot2" v-if="item.sum!=0">{{item.sum}}</span>
            </div>
            <div class="avator bg-cyan" v-if="item.messageType==8">
              <img src="../../assets/img/zixun.png"  />
              <span class="jump-usercent-orderste-dot2" v-if="item.sum!=0">{{item.sum}}</span>
            </div>
          </van-col>
          <van-col class="right" span="19">
            <p class="header">
              <span class="title">{{item.messageTypeName}}</span>
              <span class="time">{{item.createtime}}</span>
            </p>
            <p class="content" v-if="item.messageType!=8">{{item.content}}</p>
             <p class="content" v-if="item.messageType==8">{{item.replyConten}}</p>
          </van-col>
         
        </van-row>
    </div>
    <van-tabbar v-model="tabActive" active-color="#3c6eeb">
      <van-tabbar-item url="#/home">
        <i slot="icon" class="iconfont icon-shouye"></i>
        首页
      </van-tabbar-item>
      <van-tabbar-item icon="label-o" url="#/cate">
        <i slot="icon" class="iconfont icon-icon-"></i>
        分类
      </van-tabbar-item>
      <van-tabbar-item icon="label-o" url="#/message/center">
        <i slot="icon" class="iconfont icon-ico_msg"></i>
        消息
      </van-tabbar-item>
      <van-tabbar-item icon="cart-o" url="#/cart">
        <i slot="icon" class="iconfont icon-gouwuche1"></i>
        购物车
      </van-tabbar-item>
      <van-tabbar-item icon="contact" url="#/usercent">
        <i slot="icon" class="iconfont icon-ziyuan2"></i>
        我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import {
  NavBar,
  Row,
  Col,
  Tab,
  Tabs,
  Button,
  List,
  Field,
  Tabbar,
  TabbarItem
} from "vant";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [Field.name]: Field,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [List.name]: List
  },
  data() {
    return {
      list: [],
      tabActive: 2,
    };
  },
  mounted() {
    document.getElementsByClassName("cont")[0].style.minHeight =
      window.innerHeight - 60 + "px";
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.$api.get(
        this.jumuc.userCenter.selGroup,
        {
          userId: localStorage.getItem("userId")
        },
        successRes => {
          if (successRes.success) {
           this.list = successRes.data;
          }
        }
      );
    },
    goChat(item) {
 
      if(item.messageType!=8){
         this.$router.push("/user/message?typeKey="+item.messageType+'&name='+item.messageTypeName);
      }else{//咨询类的
        this.$router.push("/chat/list");
      }
     
    }
  }
};
</script>

<style lang="less" scoped>
#app {
  background-color: #fff !important;
}
.jump-usercent-orderste-dot2 {
  position: absolute;
  top: -5px;
  right: -5px;
  font-size: 12px;
  width: 18px;
  background-color: red;
  color: #fff;
  border-radius: 50%;
  text-align: center;
}
.cont {
  padding: 0 10px 50px;
  background: #fff;
}
.item {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  .avator {
    width: 46px;
    height: 46px;
    border-radius: 15px;
    position: relative;
    text-align: center;
    img {
      width: 26px;
      height: 26px;
      margin-top: 10px;
    }
    .avaImg {
      width: 46px;
      height: 46px;
      margin-top: 0;
    }
  }
  .right {
    .header {
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 16px;
        color: #000;
      }
      .time {
        color: #7d7e80;
        font-size: 12px;
      }
    }
    .content {
      white-space: nowrap;
      color: #969799;
      font-size: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>